<template>
  <div>
    <!-- ĐÃ BỎ theo yêu cầu: banner "Bộ lọc sẽ lấy tối đa 100 cuộc hội thoại cá nhân gần nhất".
         (Con số này vốn cũng không đúng — sw-ai/CommonService:671-680 cho pageSize 1000 với
         công ty thuộc whitelist hoặc đang dùng gói trả phí.) -->

    <!-- Khoảng thời gian — CHỈ hiện khi chạy 1 lần (immediate / delay).
         Chạy theo lịch thì ẩn hẳn ô này và thay bằng ghi chú: buildFilters() gửi
         dateFrom/dateTo = "" để backend tự suy khoảng theo nhịp ở mỗi lần cron chạy. -->
    <div v-if="!isScheduled" class="flt-interact">
      <div class="flt-interact-lbl">
        <i class="el-icon-date"></i>
        Khoảng thời gian <span class="req">*</span>
      </div>
      <el-date-picker
        :value="dateRange"
        type="daterange"
        size="small"
        unlink-panels
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd"
        range-separator="→"
        start-placeholder="Từ ngày"
        end-placeholder="Đến ngày"
        class="flt-daterange-picker"
        @input="$emit('update:date-range', $event)" />
    </div>
    <div v-else class="flt-schedule-note">
      <i class="el-icon-info"></i>
      <span>
        Đang hẹn lịch chạy định kỳ nên <strong>khoảng thời gian được tính theo lịch ở mỗi lần chạy</strong>,
        không cần chọn khoảng cố định.
      </span>
    </div>

    <!-- Lần tương tác cuối — tuỳ chọn -->
    <div class="flt-interact">
      <div class="flt-interact-lbl">
        <i class="el-icon-time"></i>
        Lần tương tác cuối
      </div>
      <div class="flt-lastinteract-input">
        <el-input-number
          :value="lastInteractDays"
          size="small"
          :min="0"
          :max="365"
          :step="1"
          controls-position="right"
          @change="$emit('update:last-interact-days', $event || 0)" />
        <span class="flt-lastinteract-suffix">ngày trước</span>
      </div>
    </div>

    <!-- Enum toggle rows: Đọc / Trả lời (loại hội thoại mặc định = cá nhân, ẩn) -->
    <div class="flt-block inline">
      <label class="flt-block-lbl">
        <i class="el-icon-message-solid"></i>
        Trạng thái đọc
      </label>
      <div class="flt-toggle-group">
        <div
          v-for="opt in READ_STATE_OPTS"
          :key="opt.value"
          class="flt-toggle"
          :class="{on: enumValue('readState') === opt.value}"
          @click="selectEnum('readState', opt.value)">
          <i :class="opt.icon"></i>
          <span>{{ opt.label }}</span>
        </div>
      </div>
    </div>

    <div class="flt-block inline">
      <label class="flt-block-lbl">
        <i class="el-icon-chat-dot-square"></i>
        Trạng thái trả lời
      </label>
      <div class="flt-toggle-group">
        <div
          v-for="opt in REPLY_STATE_OPTS"
          :key="opt.value"
          class="flt-toggle"
          :class="{on: enumValue('replyState') === opt.value}"
          @click="selectEnum('replyState', opt.value)">
          <i :class="opt.icon"></i>
          <span>{{ opt.label }}</span>
        </div>
      </div>
    </div>

    <!-- Tài khoản Zalo (multi-select) — inline -->
    <div class="flt-block inline">
      <label class="flt-block-lbl">
        <i class="el-icon-mobile-phone"></i>
        Tài khoản Zalo
      </label>
      <el-select
        :value="filters.accountIds"
        size="small"
        placeholder="Tất cả tài khoản"
        multiple
        filterable
        collapse-tags
        clearable
        class="flt-account-select"
        :no-data-text="accounts.length ? 'Không tìm thấy' : 'Chưa có tài khoản Zalo'"
        @change="update('accountIds', $event)">
        <el-option
          v-for="a in accounts"
          :key="a.accountId"
          :label="a.displayName || a.swName || a.accountId"
          :value="a.accountId" />
      </el-select>
    </div>

    <!-- Tag (chip list giống sidebar) — frame bao quanh -->
    <div class="flt-block">
      <label class="flt-block-lbl">
        <i class="el-icon-collection-tag"></i>
        Tag
        <span v-if="filters.tagIds && filters.tagIds.length" class="flt-block-count">
          {{ filters.tagIds.length }}
        </span>
      </label>

      <div class="flt-tag-frame">
        <el-checkbox
          :value="!!filters.noTag"
          class="flt-tag-notag"
          @change="update('noTag', $event)">
          Chỉ lấy hội thoại chưa gắn tag
        </el-checkbox>

        <div v-if="!tags.length" class="flt-empty-hint" style="margin-top:6px">
          Chưa có tag. Vào "Cài đặt tag" để thêm.
        </div>
        <template v-else>
          <el-input
            v-model="tagSearch"
            size="mini"
            placeholder="Tìm tag..."
            prefix-icon="el-icon-search"
            clearable
            class="flt-tag-search"
            :disabled="!!filters.noTag" />
          <div class="flt-tag-list" :class="{disabled: !!filters.noTag}">
            <div
              v-for="t in filteredTags"
              :key="t.id"
              class="flt-tag-chip"
              :class="{on: isTagOn(t.id)}"
              :style="tagChipStyle(t)"
              @click="filters.noTag ? null : toggleTag(t.id)">
              <span class="flt-tag-dot" :style="{ background: t.color || '#3B5BDB' }"></span>
              {{ t.name }}
            </div>
            <div v-if="!filteredTags.length" class="flt-tag-no-result">Không tìm thấy tag</div>
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
const READ_STATE_OPTS = [
  { value: 'all', label: 'Tất cả', icon: 'el-icon-s-grid' },
  { value: 'unread', label: 'Chưa đọc', icon: 'el-icon-message' },
  { value: 'read', label: 'Đã đọc', icon: 'el-icon-message-solid' },
];

const REPLY_STATE_OPTS = [
  { value: 'all', label: 'Tất cả', icon: 'el-icon-s-grid' },
  { value: 'unreplied', label: 'Chưa trả lời', icon: 'el-icon-chat-line-round' },
  { value: 'replied', label: 'Đã trả lời', icon: 'el-icon-chat-dot-round' },
];

export default {
  name: 'SaleAIFilterSection',

  props: {
    filters: { type: Object, required: true },
    dateRange: { type: Array, default: null },
    lastInteractDays: { type: Number, default: 0 },
    // Loại trigger đang chọn — quyết định có khoá ô "Khoảng thời gian" hay không.
    triggerType: { type: String, default: 'immediate' },
  },

  data() {
    return {
      READ_STATE_OPTS,
      REPLY_STATE_OPTS,
      tagSearch: '',
    };
  },

  computed: {
    // Chạy theo lịch (mỗi ngày / tuần / tháng) → khoảng thời gian phải TRƯỢT theo từng lần chạy,
    // nên khoá ô chọn khoảng cố định. buildFilters() cũng không gửi dateFrom/dateTo trong trường
    // hợp này → backend (sw-ai) tự tính lại mốc bắt đầu ở mỗi lần cron chạy.
    isScheduled() {
      return this.triggerType === 'daily' || this.triggerType === 'weekly' || this.triggerType === 'monthly';
    },
    accounts() { return this.app.accounts || []; },
    tags() { return this.app.tags || []; },
    filteredTags() {
      const q = (this.tagSearch || '').trim().toLowerCase();
      if (!q) return this.tags;
      return this.tags.filter(t => (t.name || '').toLowerCase().includes(q));
    },
  },

  mounted() {
    if (!this.accounts.length && typeof this.fetchAccountList === 'function') {
      this.fetchAccountList().catch(() => {});
    }
    if (!this.tags.length && typeof this.fetchAllTags === 'function') {
      this.fetchAllTags().catch(() => {});
    }
    this.normalizeEnums();
  },

  watch: {
    // Khi nạp config khác vào form → chuẩn hoá lại enum
    filters() {
      this.normalizeEnums();
    },
  },

  methods: {
    update(key, val) {
      this.$emit('update:filters', { ...this.filters, [key]: val });
    },

    // Bắt buộc luôn chọn 1 option — click chỉ đổi giá trị, không bỏ chọn
    selectEnum(key, value) {
      if (this.filters[key] === value) return;
      this.update(key, value);
    },
    enumValue(key) {
      // Mặc định "Tất cả" nếu chưa có giá trị
      return this.filters[key] || 'all';
    },
    normalizeEnums() {
      // conversationType cố định 'individual' (đã ẩn UI). Chỉ đảm bảo 2 enum còn lại có default.
      const keys = ['readState', 'replyState'];
      let changed = false;
      const next = { ...this.filters };
      if (next.conversationType !== 'individual') {
        next.conversationType = 'individual';
        changed = true;
      }
      keys.forEach(k => {
        if (!next[k]) { next[k] = 'all'; changed = true; }
      });
      if (changed) this.$emit('update:filters', next);
    },

    // Tag chips
    isTagOn(id) {
      return Array.isArray(this.filters.tagIds) && this.filters.tagIds.indexOf(id) >= 0;
    },
    toggleTag(id) {
      const cur = (this.filters.tagIds || []).slice();
      const i = cur.indexOf(id);
      if (i >= 0) cur.splice(i, 1);
      else cur.push(id);
      this.update('tagIds', cur);
    },
    tagChipStyle(t) {
      if (this.isTagOn(t.id)) {
        return { background: t.color || '#3B5BDB', borderColor: t.color || '#3B5BDB', color: '#fff' };
      }
      return {};
    },
  },
};
</script>
